module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "calendarComponent"
    }
  }, [_c('br'), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.alertMsg) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.alertMsg))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "calendar"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b00f2e6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Profile/CalendarView.vue
// module id = 654
// module chunks = 2